import { action } from 'easy-peasy';
import { IActionSetCarePlanGoals } from '../types';

const setCarePlanGoals: IActionSetCarePlanGoals = action((state, payload) => {
  state.items = payload;
});

export default setCarePlanGoals;
